import {BrowserModule, HammerModule} from "@angular/platform-browser";
import {RouterLink, RouterLinkActive, RouterModule} from "@angular/router";
import {AppRoutingModule} from "./app.routes";
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {AppComponent} from "./app.component";
import {LoginPageComponent} from "./login-page/login-page.component";
import {RegistrationComponent} from "./registration/registration.component";
import {NgModule} from '@angular/core';
import {NgbCarouselModule} from "@ng-bootstrap/ng-bootstrap";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {ProfileCardComponent} from "./profile-card/profile-card.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {HeaderComponent} from "./header/header.component";
import {ProfilePageComponent} from "./profile-page/profile-page.component";
import {ResetTokenExistComponent} from "./reset-token-exist/reset-token-exist.component";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatTabsModule} from "@angular/material/tabs";
import {NavbarComponent} from "./navbar/navbar.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {CreateCardComponent} from "./create-card/create-card.component";
import {MatInputModule} from "@angular/material/input";
import {MatChipsModule} from "@angular/material/chips";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {MatButton, MatFabButton, MatIconButton} from "@angular/material/button";
import {CommonComponent} from "./common/common.component";
import {CardsComponent} from "./cards/cards.component";
import {SlickCarouselModule} from "ngx-slick-carousel";
import {CarouselComponent} from "./carousel/carousel.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatMenuModule} from "@angular/material/menu";
import {MdbCarouselModule} from "mdb-angular-ui-kit/carousel";
import {DeleteProfileCardComponent} from "./profile-card/delete-profile-card/delete-profile-card.component";
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle
} from "@angular/material/dialog";
import {EditProfileCardComponent} from "./profile-card/edit-profile-card/edit-profile-card.component";
import {QrGenerateComponent} from "./qr-generate/qr-generate.component";
import {CardsByQrComponent} from "./cards-by-qr/cards-by-qr.component";
import {ErrorInterceptorService} from "./service/error/error-interceptor.service";
import {ErrorPageComponent} from "./error-page/error-page.component";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {SearchComponent} from "./search/search.component";
import {TokenInterceptorService} from "./service/token/token-interceptor.service";
import {AdminPageComponent} from "./admin-page/admin-page.component";
import {ContentComponent} from "./admin-page/content/content.component";
import {MatGridList, MatGridTileText} from "@angular/material/grid-list";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatCheckbox} from "@angular/material/checkbox";
import {DeleteContentComponent} from "./admin-page/delete-content/delete-content.component";
import {EditContentComponent} from "./admin-page/edit-content/edit-content.component";
import {DashboardComponent} from "./admin-page/dashboard/dashboard.component";
import {UserContentComponent} from "./user-content/user-content.component";
import {AddUserCardContentComponent} from "./add-user-card-content/add-user-card-content.component";
import {ContentListComponent} from "./admin-page/content-list/content-list.component";
import {UserCardContentEditComponent} from "./user-card-content-edit/user-card-content-edit.component";
import {UserCardContentListComponent} from "./user-card-content-list/user-card-content-list.component";
import {AdminLoginPageComponent} from "./admin-login-page/admin-login-page.component";
import {AdminContainerComponent} from "./admin-container/admin-container.component";
import {AddContentModalComponent} from "./admin-page/add-content-modal/add-content-modal.component";
import {AuthInterceptor} from "./service/auth-interceptor";
import {HashtagComponent} from "./admin-page/hashtag/hashtag.component";
import {HashtagCreateFieldComponent} from "./admin-page/hashtag-create-field/hashtag-create-field.component";
import {DeleteHashtagComponent} from "./admin-page/delete-hashtag/delete-hashtag.component";
import {EditHashtagComponent} from "./admin-page/edit-hashtag/edit-hashtag.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {DigitalHandshakesComponent} from "./homepage/sections/digital-handshakes/digital-handshakes.component";
import {
  ChooseDigitalBusinessCardComponent
} from "./homepage/sections/choose-digital-business-card/choose-digital-business-card.component";
import {
  ConnectDigitalBusinessCardComponent
} from "./homepage/sections/connect-digital-business-card/connect-digital-business-card.component";
import {
  NetworkingMadeEffortlessComponent
} from "./homepage/sections/networking-made-effortless/networking-made-effortless.component";
import {
  FrequentlyAskedQuestionsComponent
} from "./homepage/sections/frequently-asked-questions/frequently-asked-questions.component";
import {
  InstantDigitalBusinessCardsComponent
} from "./homepage/sections/instant-digital-business-cards/instant-digital-business-cards.component";
import {
  DigitalBusinessCardSharingComponent
} from "./homepage/sections/digital-business-card-sharing/digital-business-card-sharing.component";
import {
  PremiumPhysicalCardsComponent
} from "./homepage/sections/premium-physical-cards/premium-physical-cards.component";
import {FooterComponent} from "./homepage/layouts/footer/footer.component";
import {HomepageComponent} from "./homepage/homepage.component";
import {HomepageHeaderComponent} from "./homepage/layouts/homepage-header/homepage-header.component";
import {
  DigitalBusinessCardsComponent
} from "./homepage/sections/digital-business-cards/digital-business-cards.component";
import {AboutUsComponent} from "./about-us/about-us.component";
import {CardsHistoryComponent} from "./cards-history/cards-history.component";
import {CoverImageCropperDialogComponent} from "./cover-image-cropper-dialog/cover-image-cropper-dialog.component";
import {ImageCropperComponent} from "ngx-image-cropper";
import {
  ProfileImageCropperDialogComponent
} from "./profile-image-cropper-dialog/profile-image-cropper-dialog.component";

import {CdkDrag, CdkDragHandle, CdkDropList} from "@angular/cdk/drag-drop";
import {ContactUsComponent} from './contact-us/contact-us.component';
import {SocialMediaComponent} from './layouts/social-media/social-media.component';
import {FilledFormFieldComponent} from './layouts/filled-form-field/filled-form-field.component';
import {PrivacyPolicyComponent} from "./privacy-policy/privacy-policy.component";
import {CartComponent} from "./cart/cart.component";
import {CartEmptyComponent} from "./cart/cart-empty/cart-empty.component";
import {ProductsComponent} from "./products/products.component";
import {ProductCardComponent} from "./products/layouts/product-card/product-card.component";
import {PaginationComponent} from "./products/layouts/pagination/pagination.component";
import {ProductDetailsDialogComponent} from './products/modal/product-details-dialog/product-details-dialog.component';
import {ProductDetailsPageComponent} from './products/pages/product-details-page/product-details-page.component';
import {SubscriptionPlanComponent} from "./subscription-plan/subscription-plan.component";
import {
  SubscriptionPlanCardComponent
} from './subscription-plan/subscription-plan-card/subscription-plan-card.component';
import {ShippingAddressComponent} from './shipping-address/shipping-address.component';
import {OrderSummaryComponent} from './shipping-address/order-summary/order-summary.component';
import {HamburgerMenuComponent} from './homepage/layouts/hamburger-menu/hamburger-menu.component';
import {FavoriteCardsComponent} from "./favorite-cards/favorite-cards.component";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {ToggleSelectComponent} from './layouts/toggle-select/toggle-select.component';
import {ToggleComponent} from './layouts/toggle/toggle.component';
import {ProductPaymentComponent} from './product-payment/product-payment.component';
import {ScanMultiSelectComponent} from "./layouts/scan-multi-select/scan-multi-select.component";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {ShippingMethodComponent} from './shipping-method/shipping-method.component';
import {DeliverySelectComponent} from './shipping-method/delivery-select/delivery-select.component';
import {MatRadioButton} from "@angular/material/radio";
import {PhoneVerificationComponent} from './phone-verifiaction/phone-verification.component';
import {CardLivePreviewComponent} from './layouts/card-live-preview/card-live-preview.component';
import {TeamsComponent} from './teams/teams.component';
import {TeamNameEditDialogComponent} from './teams/team-name-edit-dialog/team-name-edit-dialog.component';
import {AddNewMemberInTeamComponent} from './teams/add-new-member-in-team/add-new-member-in-team.component';
import {CardsByQrPaymentComponent} from './cards-by-qr/cards-by-qr-payment/cards-by-qr-payment.component';
import {QrCopyMessageComponent} from './qr-copy-message/qr-copy.component';
import {SingleCardGridComponent} from "./single-card-grid/single-card-grid.component";
import {SingleCardListComponent} from "./single-card-list/single-card-list.component";
import {UserEditProfileComponent} from './user-edit-profile/user-edit-profile.component';
import {AcceptOrDeclinedComponent} from './accept-or-declined/accept-or-declined.component';
import {DeleteCardFromTeamComponent} from './teams/delete-card-from-team/delete-card-from-team.component';
import {
  SingleCardListEditModalComponent
} from './single-card-list/single-card-list-edit-modal/single-card-list-edit-modal.component';
import {SubscriptionPaymentComponent} from './subscription-payment/subscription-payment.component';
import {PaymentTypeComponent} from './layouts/payment-type/payment-type.component';
import {UsersCardsComponent} from "./admin-page/users-cards/users-cards.component";
import {UsersFilterComponent} from "./admin-page/users-cards/users-filter/users-filter.component";
import {UserCardUsernameEditComponent} from "./admin-page/user-card-username-edit/user-card-username-edit.component";
import {ChangePasswordComponent} from './change-password/change-password.component';
import {SidebarMobileComponent} from './sidebar/sidebar-mobile/sidebar-mobile.component';
import {InsightsComponent} from './admin-page/insights/insights.component';
import {MenuComponent} from './admin-page/menu/menu.component';
import {PromoCodeComponent} from './admin-page/promocode/promoCode.component';
import {SubscriptionsComponent} from './admin-page/subscriptions/subscriptions.component';
import {UsersComponent} from './admin-page/users/users.component';
import {ClickOutsideDirective} from './directive/clickOutsideDirective';
import {CardsSortDialogComponent} from './cards-sort-dialog/cards-sort-dialog.component';
import {MySubscriptionsComponent} from "./my-subscriptions/my-subscriptions.component";
import {CreditCardSelectComponent} from './layouts/credit-card-select/credit-card-select.component';
import {
  ConfirmCardRemovingDialogComponent
} from './my-subscriptions/confirm-card-removing-dialog/confirm-card-removing-dialog.component';
import {EditContentDialogComponent} from './edit-content-dialog/edit-content-dialog.component';
import {MatTooltip} from "@angular/material/tooltip";
import {ActivityComponent} from './activity/activity.component';
import {MatCard, MatCardContent} from "@angular/material/card";
import {TableModule} from "primeng/table";

import {CardsByQrUsernameComponent} from './cards-by-qr-username-component/cards-by-qr-username.component';
import {ReturnPolicyComponent} from './return-policy/return-policy.component';
import {MoveOrRemoveDialogComponent} from "./subscription-plan/move-or-remove-dialog/move-or-remove-dialog.component";
import {PaymentIconsComponent} from "./layouts/payment-icons/payment-icons.component";
import {PaymentReceiptComponent} from './payment-receipt/payment-receipt.component';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {ActivityDialogsComponent} from './activity/activity-dialogs/activity-dialogs.component';
import {MatDivider} from "@angular/material/divider";
import {NgxMaskDirective, provideNgxMask} from "ngx-mask";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle
} from "@angular/material/datepicker";
import {MatNativeDateModule} from '@angular/material/core';
import 'hammerjs';
import {SaveChangesComponent} from "./profile-card/save-changes-popup/save-changes.component";
import {AdminProductsComponent} from './admin-page/shop/admin-products/admin-products.component';
import {AdminOrdersComponent} from './admin-page/shop/admin-orders/admin-orders.component';
import {LanguageSelectorComponent} from './layouts/language-selector/language-selector.component';
import {
  MatStep,
  MatStepLabel,
  MatStepper,
  MatStepperIcon,
  MatStepperNext,
  MatStepperPrevious
} from "@angular/material/stepper";
import {ColorPickerModule} from "ngx-color-picker";
import {CKEditorModule} from "@ckeditor/ckeditor5-angular";
import {CanvasJSAngularChartsModule} from "@canvasjs/angular-charts";
import {AdminOrderDetailComponent} from './admin-page/shop/admin-order-detail/admin-order-detail.component';
import {DotSeparatorPipe} from "./pipe/dot-separator.pipe";
import {LocalizedMonthPipe} from "./pipe/localized-month.pipe";
import {
  TeamTransactionPermissionModalComponent
} from "./teams/team-transaction-permission-modal/team-transaction-permission-modal.component";
import {
  AdminProductManageComponent
} from './admin-page/shop/admin-products/admin-product-save-edit/admin-product-manage.component';
import {AdminActivityComponent} from "./admin-page/admin-activity/admin-activity.component";
import {GoogleAdsComponent} from './google-ads/google-ads.component';
import {
  UserCardCommissionEditComponent
} from "./admin-page/user-card-commission-edit/user-card-commission-edit.component";
import {UserCardPaymentQrPageComponent} from "./user-card-payment-qr-page/user-card-payment-qr-page.component";
import {AdminQrGeneratorComponent} from "./admin-page/admin-qr-generator/admin-qr-generator.component";
import { ReservedQrCardsComponent } from './reserved-qr-cards/reserved-qr-cards.component';
import { ReservedQrActivationPageComponent } from './reserved-qr-activation-page/reserved-qr-activation-page.component';
import {ConnectReservedQrComponent} from "./connect-reserved-qr/connect-reserved-qr.component";
import {CardsByQrRatingComponent} from './cards-by-qr/cards-by-qr-rating/cards-by-qr-rating.component';
import {RatingComponent} from './layouts/rating/rating.component';
import {
  CardsByQrManageRatingComponent
} from './cards-by-qr/cards-by-qr-rating/cards-by-qr-manage-rating/cards-by-qr-manage-rating.component';
import {
  ConfirmActionWithReviewsComponent
} from './cards-by-qr/cards-by-qr-rating/dialogs/confirm-action-with-reviews/confirm-action-with-reviews.component';
import { ReviewsComponent } from './admin-page/reviews/reviews.component';
import {FeeComponent} from './admin-page/fee/fee.component';
import {UserFeeComponent} from './fee/fee.component';
import {FeeGroupCreateComponent} from './fee-group-create/fee-group-create.component';
import {FeeGroupDetailComponent} from './fee-group-detail/fee-group-detail.component';
import {FeeGroupHeaderComponent} from './fee-group-header/fee-group-header.component';
import {FeeInvoiceStatsComponent} from './fee-invoice-stats/fee-invoice-stats.component';
import {FeeWelcomeSetupComponent} from './fee-welcome-setup/fee-welcome-setup.component';
import {FeeSearchBarComponent} from './fee-search-bar/fee-search-bar.component';
import {FeeAddMemberDialogComponent} from './fee-add-member-dialog/fee-add-member-dialog.component';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {FeeMemberProfileComponent} from './fee-member-profile/fee-member-profile.component';
import {FeePaymentPageComponent} from './fee-payment-page/fee-payment-page.component';
import {FeePaymentFormComponent} from './fee-payment-form/fee-payment-form.component';
import {FeeEditPersonalInfoDialogComponent} from './fee-edit-personal-info-dialog/fee-edit-personal-info-dialog.component';
import {FeeEditEmergencyContactDialogComponent} from './fee-edit-emergency-contact-dialog/fee-edit-emergency-contact-dialog.component';
import {FeeRegisterSubgroupDialogComponent} from './fee-register-subgroup-dialog/fee-register-subgroup-dialog.component';
import {FeeRemoveSubgroupConfirmDialogComponent} from './fee-remove-subgroup-confirm-dialog/fee-remove-subgroup-confirm-dialog.component';
import {FeeEndBillingUnpaidDialogComponent} from './fee-end-billing-unpaid-dialog/fee-end-billing-unpaid-dialog.component';
import {FeeGroupPageComponent} from './fee-group-page/fee-group-page.component';
import {SubgroupFormDialogComponent} from './fee-subgroup-form-dialog/fee-subgroup-form-dialog.component';
import {SubgroupDeleteDialogComponent} from './fee-subgroup-delete-dialog/fee-subgroup-delete-dialog.component';
import {GroupDeleteDialogComponent} from './fee-group-delete-dialog/fee-group-delete-dialog.component';
import {GroupNameEditDialogComponent} from './fee-group-name-edit-dialog/fee-group-name-edit-dialog.component';
import { MenuCreateFieldComponent } from './admin-page/menu/menu-create-field/menu-create-field.component';
import { MenuQrModalComponent } from './admin-page/menu/menu-qr-modal/menu-qr-modal.component';
import { MenuShowQrModalComponent } from './admin-page/menu/menu-show-qr-modal/menu-show-qr-modal.component';
import { DeleteMenuDialogComponent } from './admin-page/menu/delete-menu-dialog/delete-menu-dialog.component';
import { MenuViewComponent } from './menu-view/menu-view.component';
import { MenuPaymentComponent } from './menu-payment/menu-payment.component';
import { CommissionsComponent } from './admin-page/commissions/commissions.component';
import { CommissionTabDialogComponent } from './admin-page/commissions/commission-tab-dialog/commission-tab-dialog.component';
import { MenuFilterDialogComponent } from './admin-page/menu/menu-filter-dialog/menu-filter-dialog.component';
import { FeePaymentFilterDialogComponent } from './fee-payment-filter-dialog/fee-payment-filter-dialog.component';
import { ApplePayButtonComponent } from './layouts/apple-pay-button/apple-pay-button.component';
import { FeeIndustryDeleteDialogComponent } from './fee-industry-delete-dialog/fee-industry-delete-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    CarouselComponent,
    AppComponent,
    LoginPageComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ProfileCardComponent,
    SidebarComponent,
    HeaderComponent,
    ProfilePageComponent,
    ResetTokenExistComponent,
    NavbarComponent,
    CreateCardComponent,
    CommonComponent,
    CardsComponent,
    DeleteProfileCardComponent,
    EditProfileCardComponent,
    QrGenerateComponent,
    CardsByQrComponent,
    ErrorPageComponent,
    SearchComponent,
    AdminPageComponent,
    ContentComponent,
    DeleteContentComponent,
    EditContentComponent,
    DashboardComponent,
    ContentListComponent,
    UserContentComponent,
    AddUserCardContentComponent,
    UserCardContentEditComponent,
    UserCardContentListComponent,
    AdminLoginPageComponent,
    AdminContainerComponent,
    AddContentModalComponent,
    HashtagComponent,
    HashtagCreateFieldComponent,
    DeleteHashtagComponent,
    EditHashtagComponent,
    HomepageComponent,
    DigitalBusinessCardsComponent,
    NetworkingMadeEffortlessComponent,
    DigitalHandshakesComponent,
    InstantDigitalBusinessCardsComponent,
    DigitalBusinessCardSharingComponent,
    ChooseDigitalBusinessCardComponent,
    ConnectDigitalBusinessCardComponent,
    PremiumPhysicalCardsComponent,
    FrequentlyAskedQuestionsComponent,
    FooterComponent,
    HomepageHeaderComponent,
    AboutUsComponent,
    CardsHistoryComponent,
    CoverImageCropperDialogComponent,
    ProfileImageCropperDialogComponent,
    CartComponent,
    CartEmptyComponent,
    ContactUsComponent,
    SocialMediaComponent,
    FilledFormFieldComponent,
    PrivacyPolicyComponent,
    ProductsComponent,
    ProductCardComponent,
    PaginationComponent,
    ShippingAddressComponent,
    OrderSummaryComponent,
    FavoriteCardsComponent,
    HamburgerMenuComponent,
    ProductPaymentComponent,
    ToggleSelectComponent,
    ShippingMethodComponent,
    DeliverySelectComponent,
    PhoneVerificationComponent,
    ProductDetailsDialogComponent,
    ProductDetailsPageComponent,
    SubscriptionPlanComponent,
    SubscriptionPlanCardComponent,
    ToggleComponent,
    ScanMultiSelectComponent,
    CardLivePreviewComponent,
    TeamsComponent,
    TeamNameEditDialogComponent,
    AddNewMemberInTeamComponent,
    QrCopyMessageComponent,
    CardsByQrPaymentComponent,
    SingleCardGridComponent,
    SingleCardListComponent,
    AcceptOrDeclinedComponent,
    UserEditProfileComponent,
    SubscriptionPaymentComponent,
    PaymentTypeComponent,
    DeleteCardFromTeamComponent,
    SingleCardListEditModalComponent,
    UsersCardsComponent,
    UsersFilterComponent,
    UserCardUsernameEditComponent,
    ChangePasswordComponent,
    SidebarMobileComponent,
    SingleCardListEditModalComponent,
    InsightsComponent,
    MenuComponent,
    PromoCodeComponent,
    SubscriptionsComponent,
    UsersComponent,
    ClickOutsideDirective,
    CardsSortDialogComponent,
    MySubscriptionsComponent,
    CreditCardSelectComponent,
    ConfirmCardRemovingDialogComponent,
    EditContentDialogComponent,
    CardsByQrUsernameComponent,
    ReturnPolicyComponent,
    EditContentDialogComponent,
    MoveOrRemoveDialogComponent,
    ReturnPolicyComponent,
    PaymentReceiptComponent,
    PaymentIconsComponent,
    MoveOrRemoveDialogComponent,
    ActivityComponent,
    ActivityDialogsComponent,
    SaveChangesComponent,
    AdminProductsComponent,
    AdminOrdersComponent,
    LanguageSelectorComponent,
    AdminOrderDetailComponent,
    TeamTransactionPermissionModalComponent,
    AdminProductManageComponent,
    AdminActivityComponent,
    GoogleAdsComponent,
    UserCardCommissionEditComponent,
    UserCardPaymentQrPageComponent,
    CardsByQrRatingComponent,
    RatingComponent,
    CardsByQrManageRatingComponent,
    ConfirmActionWithReviewsComponent,
    UserCardPaymentQrPageComponent,
    AdminQrGeneratorComponent,
    ReservedQrCardsComponent,
    ReservedQrActivationPageComponent,
    ConnectReservedQrComponent,
    AdminQrGeneratorComponent,
    ReviewsComponent,
    MenuCreateFieldComponent,
    MenuQrModalComponent,
    MenuShowQrModalComponent,
    DeleteMenuDialogComponent,
    MenuViewComponent,
    MenuPaymentComponent,
    CommissionsComponent,
    CommissionTabDialogComponent,
    ApplePayButtonComponent,
    FeeComponent,
    UserFeeComponent,
    FeeGroupCreateComponent,
    FeeGroupDetailComponent,
    FeeGroupHeaderComponent,
    FeeInvoiceStatsComponent,
    FeeWelcomeSetupComponent,
    FeeSearchBarComponent,
    FeeAddMemberDialogComponent,
    FeeMemberProfileComponent,
    FeePaymentPageComponent,
    FeePaymentFormComponent,
    FeeEditPersonalInfoDialogComponent,
    FeeEditEmergencyContactDialogComponent,
    FeeRegisterSubgroupDialogComponent,
    FeeRemoveSubgroupConfirmDialogComponent,
    FeeEndBillingUnpaidDialogComponent,
    FeeGroupPageComponent,
    SubgroupFormDialogComponent,
    SubgroupDeleteDialogComponent,
    GroupDeleteDialogComponent,
    GroupNameEditDialogComponent,
    MenuFilterDialogComponent,
    FeePaymentFilterDialogComponent,
    FeeIndustryDeleteDialogComponent,
    LocalizedMonthPipe,
  ],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'hy',
      useDefaultLang: false,
    }),
    MdbCarouselModule,
    SlickCarouselModule,
    MatChipsModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    RouterLinkActive,
    RouterLink,
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbCarouselModule,
    MatIconModule,
    MatIconButton,
    MatTabsModule,
    MatIcon,
    MatSlideToggleModule,
    MatMenuModule,
    MatFabButton,
    MatDialogClose,
    NgOptimizedImage,
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatProgressSpinner,
    MatSnackBarModule,
    MatGridList,
    MatGridTileText,
    MatSelect,
    MatOption,
    MatCheckbox,
    MatDialogModule,
    ImageCropperComponent,
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
    NgSelectModule,
    MatButtonToggle,
    MatButtonToggleGroup,
    MatRadioButton,
    MatTooltip,
    MatCard,
    MatCardContent,
    TableModule,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    MatDivider,
    NgxMaskDirective,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    BrowserModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStep,
    MatStepper,
    MatStepperPrevious,
    MatStepLabel,
    MatStepperNext,
    MatStepperIcon,
    CKEditorModule,
    ColorPickerModule,
    HammerModule,
    CanvasJSAngularChartsModule,
    DotSeparatorPipe,
    NgxIntlTelInputModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    HttpClient,
    provideNgxMask()
  ],
  exports: [
    HeaderComponent,
    HomepageHeaderComponent,
    FooterComponent,
    FrequentlyAskedQuestionsComponent,
    ProductCardComponent,
    PaginationComponent,
    ToggleComponent,
    ToggleSelectComponent,
    ScanMultiSelectComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
